import { Validator } from 'vee-validate';

enum UserRoleEnum {
  super = 1,
  manager,
  inspector
}

export enum ProcessStateEnum {
  to_be_planned_for_inspection = 1,
  ready_for_inspection,
  postponed_for_inspection,
  suspended_onsite_inspection,
  check_and_send,
  rejected,
  feedback_inspector,
  ready_to_send,
  sent_length,
  ready_for_server_calibration,
  suspended_server_calibration,
  process_server_calibration,
  check_dossier,
  ready_for_signing,
  awaiting_signature,
  signed,
  emetro,
  to_be_invoiced,
  finished,
  deleted
}

export interface VForm {
  $validator: Validator;
  validate();
  resetValidation();
}

export interface IUserProfile {
  email: string;
  is_active: boolean;
  is_superuser: boolean;
  full_name: string;
  id: number;
  display_name: string;
  userrole_id: UserRoleEnum;
  userrole_name: string;
  rolemap: object;
}

export interface NavItem {
  name: string;
  url: string;
  menuItems?: MenuItem[];
  privilege: string;
}

export interface MenuItem {
  name: string;
  url: string;
  privilege: string;
}

export interface Pagination {
  last_page: number;
  page: number;
  per_page: number;
  total: number;
  filter_hash?: string;
}

export interface TableData {
  data: IDRec[];
  pagination: Pagination;
  totals?: object;
}

export interface PaginationQueryParams {
  page: number;
  per_page: number;
  sort?: string;
}
export interface IDRec {
  id: number;
  prev_id?: number;
  next_id?: number;
}

export interface TableOptions {
  itemsPerPage: number;
  multiSort: boolean;
  mustSort: boolean;
  page: number;
  sortBy: string[];
  sortDesc: boolean[];
}

export interface TableConfig {
  advancedSearchFields?: SearchField[];
  addRecord?: boolean;
  apiUrl: string;
  detailTitle: string;
  deletable: boolean;
  deleteTitle?: string;
  editable: boolean;
  duplicatable?: boolean;
  forEdit?: boolean;
  multiSelect?: boolean;
  multiSort?: boolean;
  overviewTitle: string;
  overviewUrl?: string;
  priv?: string;
  sortBy: string[];
  sortDesc: boolean[];
  quickFilter: QuickFilter;
  filterName: string;
  tableFields: TableField[];
  url: string;
  newRecord: object;
  customEditable?(context: object, item: object): boolean;
  customDeletable?(context: object, item: object): boolean;
}

export interface QuickFilter {
  text: string;
  value: string;
  type?: string;
}

export interface TableField {
  align?: string;
  link?: string;
  sortable?: boolean;
  text: string;
  type?: string;
  value: string;
  width?: string;
  filter?: string;
  access?: string;
}

export interface SearchField {
  text: string;
  type?: string;
  optionListName?: string;
  optionListParams?: object;
  optionListDynamicParams?: object;
  value: string;
}

export interface ChoiceOption {
  text: string;
  value: number | string;
  id?: number;
}

export interface ChoiceOptionList {
  records: ChoiceOption[];
  checksum: string;
  timestamp?: number;
}

export interface AutoCompleteList {
  records: string[];
}

export interface Option {
  value: number;
  text: string;
}

export interface APIResult {
  status: boolean;
  info: string;
  id?: number;
}


export interface OverviewLayoutITF {
  loading: boolean;
  setFilter(f: object): void;
  tableUpdateData(resetPage: boolean): void;
  countSelections(): number;
  getSelectedIds(): number[];
  filteredOverview(): boolean;
  getFilterValues(filters: object): void;
  getSortString(): string;
}

export interface DetailLayoutITF {
  getRecord(): void;
  saveRecord(): void;
  commitRecord(rec: object): void;
}

export interface ReportFileTableITF {
  saveAllFiles(id: number): void;
}

export interface FileRec {
  id: number;
  name: string;
  size: number;
  timestamp: string;
  ext: string;
  url: string;
}

export interface PicRec {
  id: number;
  context_index: number;
  onsitepicturetype_id: number;
  file: FileRec | null;
}

export interface PicTypeRec {
  id: number;
  context_site_pole: boolean;
  context_camera: boolean;
  name: string;
  min_occurance: number;
  // sort_order: number;
}

export interface PicList {
  pictype: PicTypeRec;
  pics: PicRec[];
}

export interface PicListSet {
  title: string;
  pics: PicList[];
}

export interface DocRec {
  id: number;
  inspectiondocumenttype_id: number;
  inspectiondocumenttype_name: string;
  file: FileRec | null;
}

export interface DocTypeRec {
  id: number;
  name: string;
  // min_occurance: number;
  // sort_order: number;
}
